// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:46:13.373Z
// Property: Sundance Newton Apartments (ID: 6767906449167519)
// Collections: 16 amenities, 2 floorplans (live), 11 photos, 35 POIs, 1 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167519",
  "property_external_id": "5685518",
  "property_zillow_url": "https://www.zillow.com/apartments/newton-ia/sundance-newton-apartments/5ZTb2x/",
  "property_apartments_url": "https://www.apartments.com/sundance-newton-apartments-newton-ia/1mgwqg6/",
  "property_google_business_url": "https://www.google.com/maps/place/Newton+Sundance+Apartments/@41.7014587,-93.0185673,884m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87ef1ca014700953:0x6a18eeb7235123d3!8m2!3d41.7014587!4d-93.0185673!16s%2Fg%2F1tdrxwcq?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58388049222",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "sundance-newton-apartments",
  "property_name": "Sundance Newton Apartments",
  "property_website_url": "https://www.sundancenewtonapartments.com/",
  "property_domain": "https://www.sundancenewtonapartments.com/",
  "property_address": "220 E 28th St N",
  "property_full_address": "220 E 28th St N, Newton, IA 50208",
  "property_address_1": "220 E 28th St N",
  "property_address_2": null,
  "property_address_city": "Newton",
  "property_address_state": "IA",
  "property_address_zip_full": "50208-2747",
  "property_address_zip": "50208",
  "property_address_country": "US",
  "property_address_county": "Jasper County",
  "property_neighborhood_address": "Jasper County",
  "property_address_latitude": "41.7015363",
  "property_address_longitude": "-93.0185094",
  "property_email": "sundancenewton@dietzpropertygroup.com",
  "property_phone": "(641) 787-0400",
  "property_call_tracking_phone": "641-831-8111",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://www.dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Sundance Newton Apartments, find the ideal balance of comfort and convenience with spacious two and three-bedroom floor plans. Enjoy amenities like an on-site playground, air conditioning, and large closets. With laundry facilities and dedicated management, your new home in Newton, IA, awaits. Schedule a tour or browse availability today!",
  "property_long_description": "Welcome to Sundance Newton Apartments, your ideal retreat nestled in the heart of Newton, IA. Our vibrant community offers a selection of spacious two and three-bedroom floor plans designed to meet your lifestyle needs. Each apartment features modern conveniences like air conditioning, a dishwasher, and large closets that provide both function and style. \n\nAt Sundance Newton, we believe in elevating your living experience. Our residents enjoy fantastic on-site amenities, including convenient laundry facilities, a fun-filled playground for the little ones, and dedicated on-site maintenance and management teams ready to assist you. Plus, with water and sewer included in your rent, you can enjoy stress-free living every month.\n\nImagine unwinding in your new home after a long day, with ample space to relax and entertain. Our community fosters a sense of belonging, making it the perfect place for families and individuals alike. Whether you’re savoring quiet moments indoors or enjoying the beautiful outdoor spaces, Sundance Newton Apartments provides the comfort and convenience you desire.\n\nReady to discover your new home? Browse our availability today or schedule a tour to visit our welcoming community. Experience the perfect blend of comfort, convenience, and community at Sundance Newton Apartments—where your next chapter begins!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46ec-2af7-710e-8987-69e6fd7bab80.webp",
  "property_featured_image_media": {
    "alt_text": "Sundance Newton Apartments monument sign with playground and building in background.",
    "public_id": "019e46ec-2af7-710e-8987-69e6fd7bab80",
    "storage_key": "property/6767906449167519/019e46ec-2af7-710e-8987-69e6fd7bab80.webp",
    "width": 900,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "40",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Maximum of 2 animals per unit. All pets must be spayed/neutered, over one year old, licensed, inoculated, and certified by a veterinarian.",
  "property_pet_policy_description": "CATS are allowed (up to 35 lbs each). One-time fee: $250 per cat. Monthly pet rent: $50 per cat. DOGS are allowed (up to 50 lbs each). One-time fee: $250 per dog. Monthly pet rent: $50 per dog. Maximum of 2 animals per unit. All pets must be spayed/neutered, over one year old, licensed, inoculated, and certified by a veterinarian.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://sundancenewton.loftliving.com/",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019ef545-2d5f-7356-8ea0-7173abe34ae2.webp",
  "property_primary_logo_media": {
    "alt_text": "Sundance Newton Apartments logo",
    "public_id": "019ef545-2d5f-7356-8ea0-7173abe34ae2",
    "storage_key": "property/6767906449167519/019ef545-2d5f-7356-8ea0-7173abe34ae2.webp",
    "width": 2000,
    "height": 2000
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019ef545-2d5f-7356-8ea0-7173abe34ae2.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sundance Newton Apartments logo",
    "public_id": "019ef545-2d5f-7356-8ea0-7173abe34ae2",
    "storage_key": "property/6767906449167519/019ef545-2d5f-7356-8ea0-7173abe34ae2.webp",
    "width": 2000,
    "height": 2000
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019ef545-2e49-7679-ad02-e1ab824f58c1.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sundance Newton Apartments logo",
    "public_id": "019ef545-2e49-7679-ad02-e1ab824f58c1",
    "storage_key": "property/6767906449167519/019ef545-2e49-7679-ad02-e1ab824f58c1.webp",
    "width": 2000,
    "height": 2000
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#757B77",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "828 - 926",
  "property_sqft_min": "828",
  "property_sqft_max": "926",
  "property_price_range": "805 - 945",
  "property_price_min": "805",
  "property_price_max": "945",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/EastTownApartmentsofNewton/",
  "property_instagram_url": null,
  "property_twitter_url": "https://twitter.com/pre_three",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJUwlwFKAc74cR0yNRI7fuGGo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/newton-place-apartments-newton",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sundance Newton Apartments",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Sundance Newton Apartments in charming Newton, IA, where comfortable living meets convenience. Enjoy spacious floor plans with large closets, modern appliances, and air conditioning. Engage in delightful afternoons at the playground or rely on our dedicated on-site maintenance team for assistance. Experience the perfect balance of relaxation and community!",
  "property_home_floorplans_blurb": "Welcome to Sundance Newton Apartments, where modern living meets comfort in the heart of Newton, IA. Our diverse floor plans cater to your unique lifestyle, offering spacious layouts and inviting finishes. Browse our available apartment homes today and find the ideal space that feels just like home.",
  "property_home_gallery_blurb": "At Sundance Newton Apartments, comfort meets convenience in the heart of Newton, IA. Enjoy spacious floor plans with large closets, on-site management, and air conditioning for year-round comfort. With amenities like laundry facilities, a playground, and even water/sewer included, picture yourself living in a community that truly feels like home!",
  "property_home_neighborhood_blurb": "Welcome to Sundance Newton Apartments, where vibrant community life meets local charm. Nestled in Newton, IA, our residents enjoy nearby gems like the Newton Public Library, DMACC Newton Campus, and beautiful parks such as Maytag Park and the Arboretum. Experience a perfect blend of comfort and culture.",
  "property_home_reviews_blurb": "At Sundance Newton Apartments, residents rave about the vibrant community atmosphere, with one resident noting, “The sense of belonging here is truly special.” Nestled in beautiful Newton, IA, our apartments offer a welcoming retreat filled with modern amenities. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Sundance Newton Apartments, your new home is nestled in a vibrant community rich with history and recreation. Enjoy proximity to beautiful parks like Maytag Park and the Newton Arboretum, or delve into local history at the Jasper County Historical Museum. Unleash your adventurous spirit while living in comfort!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sundance Newton Apartments, find your perfect sanctuary with spacious two and three-bedroom layouts. Enjoy delightful amenities like playgrounds, convenient laundry facilities, and on-site management. With air conditioning and large closets, you'll feel right at home. Dive into a vibrant lifestyle where comfort meets community in Newton, IA!",
  "property_applynow_blurb": "At Sundance Newton Apartments, spacious two and three-bedroom layouts welcome you to a world of comfort. Enjoy modern amenities like air conditioning, large closets, and convenient on-site management. With a playground and laundry facilities just steps away, your perfect home awaits. Lease online today and start your new adventure!",
  "property_contactus_blurb": "At Sundance Newton Apartments in the heart of Newton, IA, you'll find spacious two and three-bedroom floor plans designed for comfort and style. Whether you’re seeking cozy living or room to grow, we have the perfect space for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Sundance Newton Apartments in Newton, IA, choose from spacious two and three-bedroom floor plans designed with your comfort in mind. Have questions? Our FAQs page is your go-to resource for clarifying life in our vibrant community, ensuring you find the perfect fit for your lifestyle.",
  "property_floorplans_blurb": "At Sundance Newton Apartments in vibrant Newton, IA, our spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Each layout is designed for modern living, ensuring you feel right at home. Browse our available apartment homes today and find your ideal space tailored for you!",
  "property_gallery_blurb": "At Sundance Newton Apartments, spacious two- and three-bedroom floor plans await, complete with modern amenities like air conditioning, dishwashers, and large closets. Picture yourself unwinding in our playground or enjoying the convenience of on-site maintenance. Your ideal home in Newton, IA, is just a click away—explore our photo gallery now!",
  "property_interactivemap_blurb": "At Sundance Newton Apartments, spacious two and three-bedroom layouts complement our inviting amenities, from laundry facilities and air conditioning to a fun-filled playground. Embrace comfortable living in the heart of Newton, IA. Use our interactive community map to find your perfect home and discover exceptional living today!",
  "property_pets_blurb": "At Sundance Newton Apartments, your furry friends are family! With a welcoming policy for cats and dogs—up to 50 lbs—you can enjoy a cozy home together. Complete with pet-friendly amenities, our community ensures you and your pets experience a harmonious lifestyle in the heart of Newton, IA.",
  "property_referafriend_blurb": "At Sundance Newton Apartments in Newton, IA, spacious two and three-bedroom floor plans provide the perfect setting for comfort and connection. Share your vibrant community with friends and elevate your living experience. Great friends make great neighbors—refer a friend today and start building lasting memories together!",
  "property_residentaccess_blurb": "Experience the comfort of home at Sundance Newton Apartments in Newton, IA, where spacious two and three-bedroom floor plans cater to your lifestyle needs. Easily manage your living experience—access the resident portal to pay rent, schedule maintenance, and stay connected. Your oasis awaits!",
  "property_reviews_blurb": "Nestled in the heart of Newton, IA, Sundance Newton Apartments boasts glowing testimonials from our residents. One happy tenant raves, “The staff goes above and beyond to ensure we feel at home.” Curious about their experiences? See what our residents have to say about living at our vibrant community!",
  "property_created_at": "1779306289244",
  "property_scheduletour_blurb": "At Sundance Newton Apartments in vibrant Newton, IA, spacious two and three-bedroom floor plans await your personal touch. Experience comfortable living in a thriving community. Ready to learn more? Schedule a tour today and check out resident testimonials to see why our community feels like home!",
  "property_thankyou_blurb": "Thank you for connecting with Sundance Newton Apartments in charming Newton, IA! With spacious two and three-bedroom floor plans tailored to your lifestyle, our community offers the perfect blend of comfort and convenience. Stay tuned as our team reaches out to share all the exciting details!",
  "property_virtualtours_blurb": "Experience the vibrant lifestyle at Sundance Newton Apartments in beautiful Newton, IA. Choose from spacious two and three-bedroom floor plans that suit your unique needs. Immerse yourself in our community through a virtual tour and envision your new home today! Your ideal living space awaits just a click away!",
  "property_copyright": "2026 All Rights Reserved. Sundance Newton Apartments",
  "property_seo_title_home": "Affordable Apartments Newton, IA | Sundance Newton",
  "property_seo_description_home": "Explore affordable apartments in Newton, IA at Sundance Newton. View 2 & 3 bedroom floor plans and learn about income qualifications and availability.",
  "property_seo_title_floorplans": "Floor Plans | Newton, IA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Sundance Newton Apartments in Newton, IA! Choose from spacious two and three-bedroom layouts that suit your lifestyle.",
  "property_seo_title_amenities": "Amenities | Newton, IA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Sundance Newton Apartments with spacious layouts, laundry, a playground, and on-site management—all in Newton, IA!",
  "property_seo_title_gallery": "Gallery | Apartments in Newton, IA",
  "property_seo_description_gallery": "Experience Sundance Newton Apartments! Enjoy spacious 2-3 bedroom homes and unbeatable amenities. Your dream life in Newton, IA awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Sundance Newton Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Sundance Newton Apartments! Enjoy spacious two and three-bedroom layouts. Take a virtual tour and envision your new home in Newton, IA!",
  "property_seo_title_interactivemap": "Interactive Map | Sundance Newton Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Sundance Newton Apartments! Explore our interactive map for two and three-bedroom options with great amenities in Newton, IA.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Newton, IA",
  "property_seo_description_neighborhood": "Uncover the charm of Sundance Newton Apartments! Dive into local favorites and hidden gems surrounding our two and three-bedroom homes in Newton, IA.",
  "property_seo_title_contact": "Contact Us | Sundance Newton Apartments",
  "property_seo_description_contact": "Experience comfort at Sundance Newton Apartments, featuring spacious two and three-bedroom floor plans in Newton, IA. Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Newton, IA",
  "property_seo_description_faqs": "Find answers to your questions about Sundance Newton Apartments. Explore our two and three-bedroom floor plans, amenities, and community life in Newton, IA!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Newton, IA",
  "property_seo_description_reviews": "Discover joy at Sundance Newton Apartments! Enjoy spacious floor plans and top amenities; read resident reviews to learn more about our community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Newton, IA",
  "property_seo_description_applynow": "Discover comfort at Sundance Newton Apartments! Choose 2 & 3-bedroom layouts with laundry, playground, and more. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Sundance Newton Apartments",
  "property_seo_description_residentaccess": "Log in to your Sundance Newton Apartments portal for easy rent payments, maintenance requests, and community updates. Stay connected with ease!",
  "property_seo_title_referafriend": "Refer A Friend | Sundance Newton Apartments",
  "property_seo_description_referafriend": "Refer a friend to Sundance Newton Apartments and build a vibrant community together! Great friends make great neighbors—share the joy of home today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Sundance Newton Apartments",
  "property_seo_description_scheduletour": "Experience vibrant living at Sundance Newton Apartments! Schedule your tour today and find your new home in the heart of Newton, IA. Embrace comfort and style!",
  "property_seo_title_privacy": "Privacy Policy | Sundance Newton Apartments",
  "property_seo_description_privacy": "Your privacy matters at Sundance Newton Apartments. Review our comprehensive policy to understand how we safeguard your information. Transparency is key!",
  "property_seo_title_accessibility": "Website Accessibility | Sundance Newton Apartments",
  "property_seo_description_accessibility": "Sundance Newton Apartments champions digital inclusion with an accessible online experience, ensuring everyone can find their perfect home in Newton, IA.",
  "property_seo_title_sitemap": "Sitemap | Sundance Newton Apartments",
  "property_seo_description_sitemap": "Navigate your way to exceptional living at Sundance Newton Apartments! Find your dream home in Newton, IA. Check out our sitemap for all the details!",
  "property_seo_title_thankyou": "Thank You | Sundance Newton Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Sundance Newton Apartments! Our team will connect with you soon to help you find your perfect home in Newton, IA.",
  "property_seo_title_pets": "Pet Policy | Apartments in Newton, IA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790198843608",
  "amenities": [
    {
      "id": "ec_3910dc37b825efc138a9e629",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_185581bee0796fad155060b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34e415b970346783a4eaa81b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7f100f8eb1866a0c415dd28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfdf765cd623fe3153bb5355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0aa5ac1317ebd5134ee4051",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a944f649586f35cfd9af9aed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32715c12541a30a8ac2a89d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Water/Sewer Included",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5213cf3e6b6ce2e953ecba0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_323705f6e71dd407ea9d00b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74931cbb372de84f503c6f33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b438fbd60df2616b30ea288c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f47fc3bb846f71b58d34dafa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63d263aea1da5b1a0388c108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2baa1c2bee98940ea19cc29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb32cbac79c78512a976af90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c4600a1d-ac4f-42cb-a7d0-2ecc66094ee7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/01a0c4e7-46cb-7044-9901-54fd65702be5.webp",
      "image_media": {
        "alt_text": "Sundance Newton Apartments monument sign.",
        "public_id": "01a0c4e7-46cb-7044-9901-54fd65702be5",
        "storage_key": "property/6767906449167519/01a0c4e7-46cb-7044-9901-54fd65702be5.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Welcome to Sundance Newton Apartments, featuring beautiful landscaping and apartment buildings. Now renting!",
      "link": "",
      "alt_text": "Sundance Newton Apartments monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a3c1001-88f8-4a9c-9026-b6c6339d2b73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/01a0c4dd-33ca-70ef-aaaa-be01567bb62d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building entrance with walkway and lawn",
        "public_id": "01a0c4dd-33ca-70ef-aaaa-be01567bb62d",
        "storage_key": "property/6767906449167519/01a0c4dd-33ca-70ef-aaaa-be01567bb62d.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Charming apartment building exterior with a well-maintained lawn and inviting entrance.",
      "link": "",
      "alt_text": "Exterior view of apartment building entrance with walkway and lawn",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f29aedc2-cef3-4105-8261-482eb8c7260a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/01a0c4dd-221d-7635-8a52-4f993f622c5d.webp",
      "image_media": {
        "alt_text": "Kitchen with white stove, refrigerator, dishwasher, and oak cabinets.",
        "public_id": "01a0c4dd-221d-7635-8a52-4f993f622c5d",
        "storage_key": "property/6767906449167519/01a0c4dd-221d-7635-8a52-4f993f622c5d.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring oak cabinetry, a white stove, refrigerator, and dishwasher, perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with white stove, refrigerator, dishwasher, and oak cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d61b131-5c34-4e5b-85bd-1414406df35f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/01a0c4dd-209b-7132-8124-9764bdb36942.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub.",
        "public_id": "01a0c4dd-209b-7132-8124-9764bdb36942",
        "storage_key": "property/6767906449167519/01a0c4dd-209b-7132-8124-9764bdb36942.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a toilet, and a bathtub/shower combination. Ample lighting above the vanity adds to the bright feel.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a9f33e8c-5641-4553-9a73-6619aae49f08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/01a0c4dd-24ee-76c9-925b-9de269b3a686.webp",
      "image_media": {
        "alt_text": "Empty bedroom with gray carpet and a window with white blinds.",
        "public_id": "01a0c4dd-24ee-76c9-925b-9de269b3a686",
        "storage_key": "property/6767906449167519/01a0c4dd-24ee-76c9-925b-9de269b3a686.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A spacious and well-lit empty bedroom featuring plush gray carpeting and a large window with adjustable blinds for privacy.",
      "link": "",
      "alt_text": "Empty bedroom with gray carpet and a window with white blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5935d759-3cdc-431b-847a-4cc536e17028",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/01a0c4dd-247e-770a-b8ee-cb93c4fe6c5e.webp",
      "image_media": {
        "alt_text": "Empty bedroom with closet and window",
        "public_id": "01a0c4dd-247e-770a-b8ee-cb93c4fe6c5e",
        "storage_key": "property/6767906449167519/01a0c4dd-247e-770a-b8ee-cb93c4fe6c5e.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious bedroom with ample closet space and a large window, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with closet and window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f793758-b8dd-4577-8460-fe42965b3906",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/01a0c4dd-335b-774b-8dc0-4732ac0aa4fb.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings on a cloudy day.",
        "public_id": "01a0c4dd-335b-774b-8dc0-4732ac0aa4fb",
        "storage_key": "property/6767906449167519/01a0c4dd-335b-774b-8dc0-4732ac0aa4fb.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our community playground, featuring slides and swings for all ages.",
      "link": "",
      "alt_text": "Playground with slides and swings on a cloudy day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d838a014-bf68-44b9-b22f-b3b0d30c1eac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/01a0c4dd-240f-7154-83e1-83c81491a08f.webp",
      "image_media": {
        "alt_text": "Exterior view of a blue apartment building with white trim, windows, and a central entrance.",
        "public_id": "01a0c4dd-240f-7154-83e1-83c81491a08f",
        "storage_key": "property/6767906449167519/01a0c4dd-240f-7154-83e1-83c81491a08f.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Exterior view of a multi-unit apartment building featuring dark blue siding, white-trimmed windows, and covered central entrances. The building includes visible air conditioning units and mailboxes.",
      "link": "",
      "alt_text": "Exterior view of a blue apartment building with white trim, windows, and a central entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c99722a4-159b-48f6-b7d3-2897c5741c63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019f054d-0749-70cd-99ca-2335bd1eab5a.webp",
      "image_media": {
        "alt_text": "Couple enjoying a meal together in their apartment kitchen.",
        "public_id": "019f054d-0749-70cd-99ca-2335bd1eab5a",
        "storage_key": "property/6767906449167519/019f054d-0749-70cd-99ca-2335bd1eab5a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy cozy meals at home. Experience the comfort and convenience of your apartment kitchen.",
      "link": "",
      "alt_text": "Couple enjoying a meal together in their apartment kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e586c7ea-ad02-49b9-8d24-cf6d3a3112b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019f054c-fa14-738e-855f-ff4dca501480.webp",
      "image_media": {
        "alt_text": "Father lifting his happy son in the air.",
        "public_id": "019f054c-fa14-738e-855f-ff4dca501480",
        "storage_key": "property/6767906449167519/019f054c-fa14-738e-855f-ff4dca501480.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "A father lifts his smiling son in the air, creating a joyful moment.",
      "link": "",
      "alt_text": "Father lifting his happy son in the air.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6cc051e5-7d0b-4f3a-9576-71d7d87aff9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019f054d-0f35-70fd-ab2a-7d07b9f93bd0.webp",
      "image_media": {
        "alt_text": "Couple walking a dog in a park.",
        "public_id": "019f054d-0f35-70fd-ab2a-7d07b9f93bd0",
        "storage_key": "property/6767906449167519/019f054d-0f35-70fd-ab2a-7d07b9f93bd0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a stroll with your furry friend in our beautiful, pet-friendly community grounds. Perfect for daily walks and outdoor relaxation.",
      "link": "",
      "alt_text": "Couple walking a dog in a park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4dced2aa-3436-4c5f-aa85-00cef190a6c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "1650 W 19th St S, Newton, IA 50208, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Diners consistently praise this restaurant's delicious burgers, chicken tenders, and fries. They also highlight the many options, including healthy choices, along with the consistently friendly service and reasonable prices.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-64c4-722a-b060-5b073bd67274.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-64c4-722a-b060-5b073bd67274",
        "storage_key": "property/6767906449167519/019e46eb-64c4-722a-b060-5b073bd67274.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.culvers.com/restaurants/newton/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=17249808082312187083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "41.6848204",
      "poi_longitude": "-93.0785571",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 641-787-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-873a-743b-bd14-1dab4e88b440",
        "storage_key": "property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm03cXnMd74cRy0zhtQ6hY-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_667fadcb-3aef-43ee-a853-253678c55ee0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Montana Mike's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1400 W 18th St S, Newton, IA 50208, USA",
      "poi_short_description": "Relaxed steakhouse chain with sirloin, ribs, wine & beer in a lodge-themed space.",
      "poi_long_description": "Diners like this steakhouse's delicious steaks, including the chicken fried steak, and other offerings like crispy chicken sandwiches and ribs. They also highlight the friendly service, great atmosphere, and reasonable prices.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6722-762f-baed-087df4a4466a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6722-762f-baed-087df4a4466a",
        "storage_key": "property/6767906449167519/019e46eb-6722-762f-baed-087df4a4466a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.montanamikes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1375253003073281165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "montana-mikes-steakhouse",
      "poi_latitude": "41.6867943",
      "poi_longitude": "-93.07633210000002",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 641-792-4582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-873a-743b-bd14-1dab4e88b440",
        "storage_key": "property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bNM2Qwd74cRjdx45FHhFRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_bbfa9acb-22f6-48b0-a67c-e9d11d94a0a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Iowa’s Best Burger Café",
      "poi_type": "Restaurants",
      "poi_address": "1570 IA-224 S, Kellogg, IA 50135, USA",
      "poi_short_description": "Part of a gas station & campground, this no-frills fast-food joint offers hamburgers & ice cream.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, ice cream, and fries, with many calling it the best burger they've ever had. They also highlight the friendly staff, fast service, and clean dining area.\n\nSome reviews mention the burgers can be frozen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6335-741b-a819-03ba0b57afde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6335-741b-a819-03ba0b57afde",
        "storage_key": "property/6767906449167519/019e46eb-6335-741b-a819-03ba0b57afde.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.iowasbestburgercafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11301927445426373554&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iowas-best-burger-caf",
      "poi_latitude": "41.684868",
      "poi_longitude": "-92.9024063",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 641-526-8535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-873a-743b-bd14-1dab4e88b440",
        "storage_key": "property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBwYqU_8Q74cRsoPgpSGD2Jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_b3308633-f78b-40df-8ebc-9fffe036cc24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Los Amigos",
      "poi_type": "Restaurants",
      "poi_address": "2002 1st Ave E, Newton, IA 50208, USA",
      "poi_short_description": "Familiar Mexican dishes such as enchiladas and fajitas served in an easygoing setting with a full bar.",
      "poi_long_description": "People say this Mexican restaurant serves delicious and authentic Mexican food, including fantastic churros and guacamole. They highlight the reasonable prices and generous portions. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6a99-7005-843c-a9bb486b3318.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6a99-7005-843c-a9bb486b3318",
        "storage_key": "property/6767906449167519/019e46eb-6a99-7005-843c-a9bb486b3318.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4827359616547538540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "los-amigos",
      "poi_latitude": "41.6994274",
      "poi_longitude": "-93.0268977",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 641-787-0019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-873a-743b-bd14-1dab4e88b440",
        "storage_key": "property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3QADd8d74cRbMZhq_45_kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7e8c132e-7832-4635-8611-740f9a0a1d42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Legends American Grill",
      "poi_type": "Restaurants",
      "poi_address": "1425 W 19th St S, Newton, IA 50208, USA",
      "poi_short_description": "Casual, kid-friendly venue dishing up familiar American favorites like burgers and steaks, plus beer, wine and cocktails.",
      "poi_long_description": "Some diners say this restaurant serves up delicious steaks, especially the ribeye, and salmon, and they praise the spicy spinach dip.\n\nOther reviews mention the service can be slow and the food can be frozen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-639b-731f-bea0-b6c807637e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-639b-731f-bea0-b6c807637e5a",
        "storage_key": "property/6767906449167519/019e46eb-639b-731f-bea0-b6c807637e5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://legendsamericangrillnewton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8257222113012361375&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legends-american-grill",
      "poi_latitude": "41.6867421",
      "poi_longitude": "-93.078325",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 641-792-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-873a-743b-bd14-1dab4e88b440",
        "storage_key": "property/6767906449167519/019e46eb-873a-743b-bd14-1dab4e88b440.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmauAiB4d74cRnyiaXcOLl3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_515fba11-2e42-41ee-b499-971a199b8fd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "1501 1st Ave E, Newton, IA 50208, USA",
      "poi_short_description": "Grocer offering fresh eats, organic options and a floral dept., as well as other staples.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6791-7315-b5e0-3048856c9eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6791-7315-b5e0-3048856c9eb1",
        "storage_key": "property/6767906449167519/019e46eb-6791-7315-b5e0-3048856c9eb1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=112&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2505533629803996199&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "41.6969198",
      "poi_longitude": "-93.0339307",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 641-792-7030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-871c-7449-a5e3-73016b4fc3fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-871c-7449-a5e3-73016b4fc3fc",
        "storage_key": "property/6767906449167519/019e46eb-871c-7449-a5e3-73016b4fc3fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE4ZmRpQc74cRJyRDuY9xxSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bba85041-a8f1-4402-8501-5556f35aaa9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "375 Iowa Speedway Dr, Newton, IA 50208, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide selection of groceries, including organic fruits and vegetables, and baked goods. They highlight the low prices, good value, and clean, well-maintained store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-672a-774e-b675-59dcc89cae19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-672a-774e-b675-59dcc89cae19",
        "storage_key": "property/6767906449167519/019e46eb-672a-774e-b675-59dcc89cae19.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ia/newton/375-iowa-speedway-dr/fn22",
      "poi_directions_map_url": "https://maps.google.com/?cid=16008117281533113664&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "41.696529",
      "poi_longitude": "-93.014695",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-871c-7449-a5e3-73016b4fc3fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-871c-7449-a5e3-73016b4fc3fc",
        "storage_key": "property/6767906449167519/019e46eb-871c-7449-a5e3-73016b4fc3fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UxEFAsb74cRQLWSWNpBKN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_27c38179-53d5-49d7-8e65-d980714513e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Fareway Meat and Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "120 N 3rd Ave E, Newton, IA 50208, USA",
      "poi_short_description": "Grocery chain selling produce & dry goods, with meat, dairy & bakery departments.",
      "poi_long_description": "People say this grocery store offers high-quality fresh produce and a superior meat counter with butcher-cut meats. They also highlight the reasonable prices and clean, uncluttered aisles. Others mention the staff provides unmatched service, including loading groceries into cars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-62ba-771e-92ef-c07ec6dc287f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-62ba-771e-92ef-c07ec6dc287f",
        "storage_key": "property/6767906449167519/019e46eb-62ba-771e-92ef-c07ec6dc287f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.fareway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4297761923404049424&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fareway-meat-and-grocery",
      "poi_latitude": "41.7020203",
      "poi_longitude": "-93.0527083",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 641-792-7950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-871c-7449-a5e3-73016b4fc3fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-871c-7449-a5e3-73016b4fc3fc",
        "storage_key": "property/6767906449167519/019e46eb-871c-7449-a5e3-73016b4fc3fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8y7o1OYc74cREKyy5bK3pDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_02ed3486-2d9e-4a09-a6c6-960c39c99cc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Dave's Wholesale Furniture",
      "poi_type": "Shopping & Retail",
      "poi_address": "2167 South 24th Ave W, Newton, IA 50208, USA",
      "poi_short_description": "Used furniture store carrying a large selection of antiques, as well as new pieces.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-677d-759b-aeaa-037388eb13f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-677d-759b-aeaa-037388eb13f5",
        "storage_key": "property/6767906449167519/019e46eb-677d-759b-aeaa-037388eb13f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16799736043705519256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-wholesale-furniture",
      "poi_latitude": "41.6771264",
      "poi_longitude": "-93.0782408",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 641-792-5566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8719-759a-9592-d391c3637dcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8719-759a-9592-d391c3637dcd",
        "storage_key": "property/6767906449167519/019e46eb-8719-759a-9592-d391c3637dcd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdczxeJ8d74cRmMxkReymJOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_1bf51306-fd91-4d80-a2d3-2a75734693c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Crazy Redhead Quilting",
      "poi_type": "Shopping & Retail",
      "poi_address": "117 1st Ave W, Newton, IA 50208, USA",
      "poi_short_description": "Local store with a wide range of quilting fabrics, patterns, kits, and machines, plus repairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-62cf-738a-a99e-a38d23d54615.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-62cf-738a-a99e-a38d23d54615",
        "storage_key": "property/6767906449167519/019e46eb-62cf-738a-a99e-a38d23d54615.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "https://www.crazyredheadquilting.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6221750092548621621&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crazy-redhead-quilting",
      "poi_latitude": "41.6993713",
      "poi_longitude": "-93.0544281",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 641-787-9122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8719-759a-9592-d391c3637dcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8719-759a-9592-d391c3637dcd",
        "storage_key": "property/6767906449167519/019e46eb-8719-759a-9592-d391c3637dcd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgUhu9Okc74cRNUWds74YWFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_e28f286b-49e1-4d94-a736-6781afac866d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "DMACC Newton Campus",
      "poi_type": "Education",
      "poi_address": "600 N 2nd Ave W, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6ae9-7166-949e-2efc023243a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6ae9-7166-949e-2efc023243a0",
        "storage_key": "property/6767906449167519/019e46eb-6ae9-7166-949e-2efc023243a0.webp",
        "width": 720,
        "height": 366
      },
      "poi_business_url": "https://www.dmacc.edu/newton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10395441172906404444&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dmacc-newton-campus",
      "poi_latitude": "41.7010527",
      "poi_longitude": "-93.0604371",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 641-791-3622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8738-7437-86fb-62fe940b8178.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8738-7437-86fb-62fe940b8178",
        "storage_key": "property/6767906449167519/019e46eb-8738-7437-86fb-62fe940b8178.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiXdj0yEd74cRXGqOWqsGRJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b87a03ee-0abe-41d7-a22a-a3ef9ef6cd41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Newton Public Library",
      "poi_type": "Education",
      "poi_address": "100 N 3rd Ave W, Newton, IA 50208, USA",
      "poi_short_description": "Quiet library that caters to children featuring a wide selection of books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6cc9-749c-87a5-23df3d72a4ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6cc9-749c-87a5-23df3d72a4ad",
        "storage_key": "property/6767906449167519/019e46eb-6cc9-749c-87a5-23df3d72a4ad.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://newtongov.org/Library",
      "poi_directions_map_url": "https://maps.google.com/?cid=16414414085152757057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newton-public-library",
      "poi_latitude": "41.7019697",
      "poi_longitude": "-93.0540823",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 641-792-4108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8738-7437-86fb-62fe940b8178.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8738-7437-86fb-62fe940b8178",
        "storage_key": "property/6767906449167519/019e46eb-8738-7437-86fb-62fe940b8178.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU9hCcd4c74cRQdWypaS2y-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_16aaff44-27c4-40cb-8cca-016d52c8e893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Newton - HA Lynn Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1205 W 6th St S #1201, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6e1e-72bd-a7d3-96a3851b3d97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6e1e-72bd-a7d3-96a3851b3d97",
        "storage_key": "property/6767906449167519/019e46eb-6e1e-72bd-a7d3-96a3851b3d97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=898325514584379214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newton---ha-lynn-stadium",
      "poi_latitude": "41.6888853",
      "poi_longitude": "-93.0603355",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8719-759a-9592-cd2ec6887636.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8719-759a-9592-cd2ec6887636",
        "storage_key": "property/6767906449167519/019e46eb-8719-759a-9592-cd2ec6887636.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ48MeIgMd74cRTs94xUt-dww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_33ec9794-7642-4834-a8cf-d3eb20f185b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Jasper County Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 S 15th Ave W, Newton, IA 50208, USA",
      "poi_short_description": "Museum focused on the history of Jasper County, with special displays at Christmastime.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-752e-7737-a286-74ee30ce2850.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-752e-7737-a286-74ee30ce2850",
        "storage_key": "property/6767906449167519/019e46eb-752e-7737-a286-74ee30ce2850.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jaspercountymuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7286173571195789475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jasper-county-historical-museum",
      "poi_latitude": "41.6855625",
      "poi_longitude": "-93.0759585",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 641-792-9118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8725-7431-85b4-8e81a018f95b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8725-7431-85b4-8e81a018f95b",
        "storage_key": "property/6767906449167519/019e46eb-8725-7431-85b4-8e81a018f95b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJPeLrkQwd74cRo-D2WkKwHWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0e24cc05-b89a-40b3-87d8-5884bded7f74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Kellogg Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "218 High St, Kellogg, IA 50135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6e9e-743d-95aa-da666d5771ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6e9e-743d-95aa-da666d5771ee",
        "storage_key": "property/6767906449167519/019e46eb-6e9e-743d-95aa-da666d5771ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kellogghistoricalsociety.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16983367669540779926&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kellogg-historical-museum",
      "poi_latitude": "41.7158447",
      "poi_longitude": "-92.9067192",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 641-526-3430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8725-7431-85b4-8e81a018f95b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8725-7431-85b4-8e81a018f95b",
        "storage_key": "property/6767906449167519/019e46eb-8725-7431-85b4-8e81a018f95b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQH1PC8Q74cRlvfU6OkKses",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bbca53c7-f7fe-483e-8144-63afb90e6d2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Retman Ranch And Dog Park",
      "poi_type": "Entertainment",
      "poi_address": "9242 S 28th Ave E, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6fb8-74ab-b53f-93dba8c3457c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6fb8-74ab-b53f-93dba8c3457c",
        "storage_key": "property/6767906449167519/019e46eb-6fb8-74ab-b53f-93dba8c3457c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5932838289042003630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "retman-ranch-and-dog-park",
      "poi_latitude": "41.67509",
      "poi_longitude": "-92.920913",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRfMllo0Q74cRrlYviP2sVVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_0a0a75c2-ec99-4f0f-8223-fe405e97ce5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "301 Iowa Speedway Dr, Newton, IA 50208, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6dd0-721d-b739-f86c5198a997.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6dd0-721d-b739-f86c5198a997",
        "storage_key": "property/6767906449167519/019e46eb-6dd0-721d-b739-f86c5198a997.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ia/newton/301-iowa-speedway-dr?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9251450438878560519&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "41.6974266",
      "poi_longitude": "-93.0150081",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 641-791-9492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTo4dmEb74cRBwF9aijBY4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_66abb701-24fa-459f-8020-67632d011770",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Newton Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2445 Hwy F 48 W, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7412-75eb-a2ed-8a30dc404065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7412-75eb-a2ed-8a30dc404065",
        "storage_key": "property/6767906449167519/019e46eb-7412-75eb-a2ed-8a30dc404065.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.newtonanimalclinic.com/?utm_source=GMBlisting&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4495918219703193938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newton-animal-clinic",
      "poi_latitude": "41.6988435",
      "poi_longitude": "-93.0825856",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 641-433-4815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZRJAmod74cRUpGd6My1ZD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_30b88640-9424-4457-b772-dbbf7d1ae884",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1707 1st Ave E, Newton, IA 50208, USA",
      "poi_short_description": "Chain fitness center offering 24/7 access, plus tanning, private showers, and free weights.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-72d1-751a-8073-2e9a74354317.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-72d1-751a-8073-2e9a74354317",
        "storage_key": "property/6767906449167519/019e46eb-72d1-751a-8073-2e9a74354317.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/newton-iowa-475/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=475",
      "poi_directions_map_url": "https://maps.google.com/?cid=12120493395172180808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "41.69879880000001",
      "poi_longitude": "-93.0317409",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 641-792-3880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJndD0aZYc74cRSMO0mYakNKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1c35d967-6aab-442d-9ff0-2e63552f1a0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Newton Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "302 S 2nd Ave W, Newton, IA 50208, USA",
      "poi_short_description": "Appointments are recommended at this nail salon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-6fd1-762a-bfce-bbba40c4b163.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-6fd1-762a-bfce-bbba40c4b163",
        "storage_key": "property/6767906449167519/019e46eb-6fd1-762a-bfce-bbba40c4b163.webp",
        "width": 621,
        "height": 1104
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7562584776458828782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newton-nails",
      "poi_latitude": "41.6987678",
      "poi_longitude": "-93.0564266",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 515-500-6596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9eANwGnF_i4R7vuaMMmy82g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_3acc316f-cc82-41d0-858d-55a5dd966d25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Urban Nails in Newton IA",
      "poi_type": "Health and Wellness",
      "poi_address": "306 1st Ave W unit 1, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-747d-7426-9a53-2536d7da6254.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-747d-7426-9a53-2536d7da6254",
        "storage_key": "property/6767906449167519/019e46eb-747d-7426-9a53-2536d7da6254.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://urbannailsnewton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8936038403825578552&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-nails-in-newton-ia",
      "poi_latitude": "41.6997284",
      "poi_longitude": "-93.0565084",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 515-988-9168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_UecBUd74cROLJFR5UvA3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_c8b42e90-608d-4643-aa1b-eca6cfff6b3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "E clips",
      "poi_type": "Health and Wellness",
      "poi_address": "225 1st Ave W, Newton, IA 50208, USA",
      "poi_short_description": "Barber and hair salon with stylists and colorists offering cuts and styling services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-77a5-744b-b462-20a6ba8e16c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-77a5-744b-b462-20a6ba8e16c0",
        "storage_key": "property/6767906449167519/019e46eb-77a5-744b-b462-20a6ba8e16c0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4297467553028321727&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "e-clips",
      "poi_latitude": "41.6993798",
      "poi_longitude": "-93.0559998",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 641-791-2547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUdBCbuAc74cRvzEFdPirozs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_2d5cd47a-ef0d-47d4-8ead-6233f4f8b688",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Parkview Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2012 1st Ave E, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7805-724b-aca4-7419a82cce36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7805-724b-aca4-7419a82cce36",
        "storage_key": "property/6767906449167519/019e46eb-7805-724b-aca4-7419a82cce36.webp",
        "width": 785,
        "height": 440
      },
      "poi_business_url": "http://www.parkviewah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1599592723821029859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parkview-animal-hospital",
      "poi_latitude": "41.699497",
      "poi_longitude": "-93.026486",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 641-792-0340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2eLXPpgc74cR4-mmeBvlMhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_81ce23ba-ba45-442b-9602-c735f009addd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "TT-Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "2617 1st Ave E Ste. 8, 9, 10, Newton, IA 50208, USA",
      "poi_short_description": "Acrylic, gel and dip powder manicures from experienced technicians alongside pedicures and eyebrow treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-79b2-7299-9967-3bc5f334b955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-79b2-7299-9967-3bc5f334b955",
        "storage_key": "property/6767906449167519/019e46eb-79b2-7299-9967-3bc5f334b955.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15380280142541552291&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tt-nails",
      "poi_latitude": "41.69835279999999",
      "poi_longitude": "-93.0213088",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 641-792-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBRpyCiUd74cRo_ouKk27cdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_1d01919d-b990-4005-a8f0-fc9444b480ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Aleya Salon Suites & Day Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "112 N 2nd Ave W, Newton, IA 50208, USA",
      "poi_short_description": "Relaxed salon offering haircuts and color treatments, as well as massage services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7aab-744d-adb7-8d922a153f57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7aab-744d-adb7-8d922a153f57",
        "storage_key": "property/6767906449167519/019e46eb-7aab-744d-adb7-8d922a153f57.webp",
        "width": 1170,
        "height": 659
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8003240347932173966&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aleya-salon-suites--day-spa",
      "poi_latitude": "41.70074839999999",
      "poi_longitude": "-93.0541381",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 641-521-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3uCI94c74cRjiaShrE4EW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_d36cb126-98fe-44d4-8f2a-6a35fcbc5c2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Tips & Toes Nails Salon Newton",
      "poi_type": "Health and Wellness",
      "poi_address": "110 1st Ave E, Newton, IA 50208, USA",
      "poi_short_description": "Relaxed-tone spot for pedicures, gel manicures, acrylics and shellac nails, plus friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7be7-7183-a652-e3cf65ac0918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7be7-7183-a652-e3cf65ac0918",
        "storage_key": "property/6767906449167519/019e46eb-7be7-7183-a652-e3cf65ac0918.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/Tips-and-Toes-Salon-126026444117317/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14496332744390324368&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tips--toes-nails-salon-newton",
      "poi_latitude": "41.6996228",
      "poi_longitude": "-93.0530422",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 641-791-2324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGWeMr-Ac74cRkLA_f9NRLck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_e58b1ad4-4b3b-4284-b922-8100be517d81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "MercyOne Newton Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "204 N 4th Ave E, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7a10-7136-a6a0-a8f0e73fab07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7a10-7136-a6a0-a8f0e73fab07",
        "storage_key": "property/6767906449167519/019e46eb-7a10-7136-a6a0-a8f0e73fab07.webp",
        "width": 1280,
        "height": 726
      },
      "poi_business_url": "https://www.mercyone.org/location/mercyone-Newton-medical-center-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095531939080739020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercyone-newton-medical-center",
      "poi_latitude": "41.703252",
      "poi_longitude": "-93.0508124",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 641-792-1273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-871a-7486-9b46-502e0d8e31f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-871a-7486-9b46-502e0d8e31f4",
        "storage_key": "property/6767906449167519/019e46eb-871a-7486-9b46-502e0d8e31f4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5GlxV0d74cRzJjI0-WJ9So",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4f630f53-3d0f-4e25-a0bd-13c1305c6599",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Westwood Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3387 Hwy F48 W, Newton, IA 50208, USA",
      "poi_short_description": "Pretty golf course with a driving range and putting green, plus a clubhouse.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7b7e-72a9-8558-5f619351776d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7b7e-72a9-8558-5f619351776d",
        "storage_key": "property/6767906449167519/019e46eb-7b7e-72a9-8558-5f619351776d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.westwoodgolfcoursenewton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=474493153086776801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westwood-golf-course",
      "poi_latitude": "41.6949464",
      "poi_longitude": "-93.0954408",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 641-792-3087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-873a-743b-bd14-1aa58a98d3c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-873a-743b-bd14-1aa58a98d3c4",
        "storage_key": "property/6767906449167519/019e46eb-873a-743b-bd14-1aa58a98d3c4.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ292goWEd74cR4aUXPgK9lQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f9ccfde9-c4df-495e-888e-02eaa9c7e007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Maytag Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "301 South 11th Ave W, Newton, IA 50208, USA",
      "poi_short_description": "Park with a pool, disc golf course, tennis court and children's playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7c38-774b-b5c5-c61947847fa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7c38-774b-b5c5-c61947847fa6",
        "storage_key": "property/6767906449167519/019e46eb-7c38-774b-b5c5-c61947847fa6.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.newtongov.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8953498207347238307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maytag-park",
      "poi_latitude": "41.6882749",
      "poi_longitude": "-93.0557549",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 641-792-1470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8743-708f-adcb-acd74eace28b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8743-708f-adcb-acd74eace28b",
        "storage_key": "property/6767906449167519/019e46eb-8743-708f-adcb-acd74eace28b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg6K3Gv0c74cRo2UHki43QXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4489f207-71ad-4bd4-97b2-00a3c09805b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Newton Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3030 N 4th Ave E, Newton, IA 50208, USA",
      "poi_short_description": "Serene 6-acre botanical garden featuring flowers, trees and plants plus paved trails.",
      "poi_long_description": "Visitors say this botanical garden features beautiful, well-cared-for gardens with winding walking paths and a variety of local flora. They also highlight that it's a peaceful place to relax and enjoy nature, especially when the flowers are in bloom. Others mention it's a great spot for events, parties, and photos, and it's free to the public.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7dfa-7189-b4e8-d24743f092aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7dfa-7189-b4e8-d24743f092aa",
        "storage_key": "property/6767906449167519/019e46eb-7dfa-7189-b4e8-d24743f092aa.webp",
        "width": 1280,
        "height": 985
      },
      "poi_business_url": "http://www.newtonarboretum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6874575041254526911&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newton-arboretum--botanical-gardens",
      "poi_latitude": "41.7036059",
      "poi_longitude": "-93.0162798",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ66QTQV4b74cRvw--s5NlZ18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_7c4804b0-8711-461c-ace6-2190c89a2db4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Mariposa County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7590 North 67th Ave E, Kellogg, IA 50135, USA",
      "poi_short_description": "Hiking, fishing and camping destination featuring a butterfly garden and play areas for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7fe5-728d-ae2e-a4828004f9b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7fe5-728d-ae2e-a4828004f9b5",
        "storage_key": "property/6767906449167519/019e46eb-7fe5-728d-ae2e-a4828004f9b5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mycountyparks.com/County/Jasper/Park/Mariposa-Park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2921901604110519561&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mariposa-county-park",
      "poi_latitude": "41.7769244",
      "poi_longitude": "-92.9610911",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 641-792-9780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8743-708f-adcb-acd74eace28b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8743-708f-adcb-acd74eace28b",
        "storage_key": "property/6767906449167519/019e46eb-8743-708f-adcb-acd74eace28b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNd_6_LgF74cRCc2mLQeujCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_761d93b2-0934-486a-b415-f51df30ea47c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Agnes Patterson Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3000 N 4th Ave E, Newton, IA 50208, USA",
      "poi_short_description": "Sprawling green space with playgrounds and ball fields (softball and baseball), as well as an arboretum and botanical garden.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-7fe4-7210-b387-e2063ed8477f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-7fe4-7210-b387-e2063ed8477f",
        "storage_key": "property/6767906449167519/019e46eb-7fe4-7210-b387-e2063ed8477f.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.newtongov.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16298041279756464096&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "agnes-patterson-memorial-park",
      "poi_latitude": "41.7068324",
      "poi_longitude": "-93.0181967",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 641-792-1470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8743-708f-adcb-acd74eace28b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8743-708f-adcb-acd74eace28b",
        "storage_key": "property/6767906449167519/019e46eb-8743-708f-adcb-acd74eace28b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ66QTQV4b74cR4G-JdjFGLuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b77ee720-4d73-4372-9051-1edc86753289",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Newton Municipal Airport - Earl Johnson Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "2901 Rusty Wallace Dr, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8291-7457-9f72-0a1973c68509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46eb-8291-7457-9f72-0a1973c68509",
        "storage_key": "property/6767906449167519/019e46eb-8291-7457-9f72-0a1973c68509.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.johnsonaviation.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11585568537618837722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newton-municipal-airport---earl-johnson-field",
      "poi_latitude": "41.6772384",
      "poi_longitude": "-93.0208053",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 641-792-1292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8975-72fb-b042-f1babb6a2b8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8975-72fb-b042-f1babb6a2b8a",
        "storage_key": "property/6767906449167519/019e46eb-8975-72fb-b042-f1babb6a2b8a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcf0YHkc74cR2nC2tTM1yKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3e68b63b-8663-47f5-8718-0cefa1fe194c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Mahaska Communications",
      "poi_type": "Major Employers & Offices",
      "poi_address": "315 W 4th St N, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.mahaska.org/newton",
      "poi_directions_map_url": "https://maps.google.com/?cid=12282183017389386110&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mahaska-communications",
      "poi_latitude": "41.70172290000001",
      "poi_longitude": "-93.0577153",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 641-841-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYGHOIod74cRfmnUaWEUc6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_624638c2-ac03-4269-b447-44fe7cf1d3c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "custom",
      "poi_name": "Lauterbach Car Lot",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2900 1st Ave E, Newton, IA 50208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lauterbachcars.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=680216472303769639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lauterbach-car-lot",
      "poi_latitude": "41.6998308",
      "poi_longitude": "-93.0166607",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 641-792-6412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46eb-8746-77ed-baf4-b74095a0a208",
        "storage_key": "property/6767906449167519/019e46eb-8746-77ed-baf4-b74095a0a208.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5klPGAb74cRJxgJEkedcAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_0d7658ae-01fa-45fd-ab04-4508f352e895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_c65e97a7-e18f-42d0-b015-dba202e652de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_6b26a585-fd31-4cd7-ac48-5de3c3476901",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_4cb6d0b1-dcdb-4545-a47b-1ebe08e9292a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_5e331efa-c9e3-41dd-a2ab-b71df66ec2ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_7d1d3ca190cb9cd6a309f6c8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "rating": "5",
      "name": "Melissa Logue",
      "text": "This Complex is extremely Well kept and the Apartments are large,Up to date ,Inviting Atomasshere as there its a large area for children to play. The location is nicely located close to Stores,Gas Stations,Botanical Garden's are close buy as are several  parks and baseball fields.",
      "date": "2023-04-16",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ed0ea-cc95-71e7-a167-59a08713d5fd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Sundance Newton Apartments Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519"
    },
    {
      "lead_collector_id": "019ed0ea-cd2a-779e-9925-b5ad55ff6e14",
      "lead_source": "LANDING_PAGE",
      "name": "Sundance Newton Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-air-conditioned-apartments",
      "search_query": "air conditioned apartments in Newton, IA",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Newton, IA",
      "h2_subtitle": "Explore comfortable living with air conditioned spaces in Newton, IA. Our community offers modern amenities for an unmatched rental experience.",
      "page_copy": "Welcome to Sundance Newton Apartments, where comfort meets convenience in the heart of Newton, IA. Our air conditioned apartments ensure a refreshing escape from the summer heat, providing a relaxing and enjoyable living environment. Located conveniently in Jasper County, our community features amenities like laundry facilities, a playground, and spacious large closets that add to the quality of life you deserve.\n\nEach apartment at Sundance comes with essential features such as large closets and W/D hookups, making daily living a breeze. The air conditioned interiors combine with modern conveniences, setting the stage for a perfect home. With easy access to local attractions and a family-friendly atmosphere, your perfect rental home awaits at Sundance Newton Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments - Newton, IA",
      "seo_description": "Discover air conditioned apartments in Newton, IA at Sundance. Enjoy modern amenities and a comfortable lifestyle in Jasper County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-apartments-with-dishwasher",
      "search_query": "apartments with dishwasher in Jasper County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Jasper County",
      "h2_subtitle": "Find the perfect apartment with a dishwasher in Jasper County. Enjoy modern living with convenient amenities at Sundance Newton Apartments.",
      "page_copy": "At Sundance Newton Apartments, located in the welcoming community of Newton, IA, you can enjoy the convenience of modern living with thoughtfully designed spaces. While our apartments do not currently include a dishwasher, we offer a range of desirable amenities that make everyday living a pleasure. Our community features playgrounds, spacious closets, and W/D hookups, ensuring a comfortable and practical living experience.\n\nNestled in the serene environment of Jasper County, Sundance Newton offers residents access to laundry facilities and garbage disposal services, all contributing to a hassle-free lifestyle. With easy access to local attractions and services around Newton, our community is the perfect place to call home. Discover the blend of comfort and convenience at our welcoming apartment community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher - Jasper County",
      "seo_description": "Explore Jasper County living at Sundance Newton Apartments. Though without dishwashers, enjoy many amenities and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-apartments-with-playground",
      "search_query": "Newton apartments with playground on site",
      "category": "Amenity",
      "h1_title": "Newton Apartments with Playground On Site",
      "h2_subtitle": "Experience family-friendly living in Newton, IA, with our on-site playground. Enjoy a community designed for all ages.",
      "page_copy": "Sundance Newton Apartments offers the perfect blend of convenience and comfort, making it an ideal place for families in Newton, IA. Our community features an on-site playground, creating a fun and safe environment right at your doorstep. Nestled in the charming Jasper County, our location provides easy access to local amenities while also offering peaceful residential living.\n\nBeyond the playground, our apartments boast amenities that cater to a wide range of needs, including large closets, disposal facilities, and W/D hookups. At Sundance Newton, we prioritize creating spaces where families can thrive and enjoy daily life. Come experience a welcoming community with everything you need to feel at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Newton Apartments with Playground On Site",
      "seo_description": "Discover Sundance Newton Apartments with on-site playground in Jasper County. Perfect for families, offering comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-spacious-closet-apartments",
      "search_query": "spacious closet apartments in Newton 50208",
      "category": "Amenity",
      "h1_title": "Spacious Closet Apartments in Newton 50208",
      "h2_subtitle": "Find ample storage space in Newton, IA, with our spacious closets. Experience organized living at Sundance Newton Apartments.",
      "page_copy": "At Sundance Newton Apartments, located in the heart of Newton, IA, we understand the importance of having ample storage in your home. Our spacious closet apartments are designed to help you keep your living area organized and clutter-free. Nestled in Jasper County, our community combines practicality with comfort, providing an ideal residential experience.\n\nEach apartment offers generously sized closets, alongside other convenient features such as laundry facilities and W/D hookups. Whether you're storing seasonal gear or expanding your wardrobe, Sundance Newton ensures that you’ll have room for everything. Embrace a comfortable lifestyle in our inviting community, where every detail is crafted with your needs in mind.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Closet Apartments - Newton 50208",
      "seo_description": "Explore Sundance Newton Apartments in 50208. Spacious closets provide ample storage in Jasper County's comfortable living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-laundry-facilities-apartments",
      "search_query": "laundry facilities apartments Newton Iowa",
      "category": "Amenity",
      "h1_title": "Laundry Facilities Apartments in Newton, Iowa",
      "h2_subtitle": "Convenient living in Newton, IA, with on-site laundry facilities. Discover hassle-free apartment living at Sundance Newton.",
      "page_copy": "Sundance Newton Apartments offers a convenient lifestyle in the heart of Newton, Iowa, with the added benefit of on-site laundry facilities. Our well-maintained laundry amenities ensure that your day-to-day tasks are made simpler, freeing up more time for you to enjoy what Jasper County has to offer. \n\nOur community is designed to provide residents with comfort and convenience, featuring lovely outdoor spaces, spacious interiors with large closets, and the option for W/D hookups in each apartment. Located in a peaceful area of Newton, Sundance Newton ensures a stress-free living environment where all necessities are close at hand. Join our vibrant community and simplify your life with our excellent amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Laundry Facilities Apartments - Newton, Iowa",
      "seo_description": "Sundance Newton Apartments offers on-site laundry facilities in Newton, Iowa. Enjoy hassle-free living with modern amenities in Jasper County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-two-bedroom-apartments",
      "search_query": "two bedroom apartments newton ia",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Newton, IA",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Newton, IA. Perfect for families and roommates seeking comfort and style.",
      "page_copy": "Explore the perfect living arrangement at Sundance Newton Apartments with our spacious two-bedroom units in the charming town of Newton, IA. Nestled in serene Jasper County, these apartments are specifically designed to accommodate small families or roommates looking for ample space and privacy.\n\nEach apartment offers well-planned layouts that maximize living areas, complete with large closets, a modern kitchen, and optional W/D hookups. Additionally, residents can enjoy community amenities such as a children's playground and laundry facilities, ensuring a comfortable lifestyle. Sundance Newton Apartments provides an inviting atmosphere, making it an excellent choice for those seeking a two-bedroom home in a welcoming community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments - Newton, IA",
      "seo_description": "Sundance Newton offers two-bedroom apartments perfect for families or roommates in Newton, IA. Enjoy spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-three-bedroom-apartments",
      "search_query": "three bedroom apartments jasper county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Jasper County",
      "h2_subtitle": "Explore spacious three-bedroom apartments in Jasper County at Sundance Newton. Ideal for families seeking comfort and convenience.",
      "page_copy": "Sundance Newton Apartments in Jasper County is proud to present our expansive three-bedroom apartments. Perfect for larger families or those who need extra space, these units offer generous layouts, ensuring plenty of room to move and live comfortably. \n\nLocated in the heart of Newton, IA, our apartment community provides modern amenities like large closets and a playground, making it an ideal home base. The on-site laundry facilities and W/D hookup options add another layer of convenience, allowing residents to enjoy a seamless lifestyle. Choose Sundance Newton for a community-focused environment that meets all your three-bedroom apartment needs with style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments - Jasper County",
      "seo_description": "Sundance Newton in Jasper County offers spacious three-bedroom apartments. Enjoy ample living space with modern amenities ideal for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-apartments-near-dmacc-campus",
      "search_query": "apartments near DMACC Newton Campus IA",
      "category": "School",
      "h1_title": "Apartments Near DMACC Newton Campus, IA",
      "h2_subtitle": "Find the perfect home near DMACC Newton Campus at Sundance Newton. Ideal for students and staff seeking convenient living.",
      "page_copy": "Discover the ideal living situation near DMACC Newton Campus by choosing Sundance Newton Apartments. Located in the heart of Newton, IA, our community offers easy access for students and faculty alike, providing a convenient and comfortable place to call home.\n\nOur apartments feature spacious layouts with large closets and the convenience of W/D hookups, complemented by community amenities including laundry facilities and a playground. Whether you're attending classes or working at the Des Moines Area Community College, living at Sundance Newton puts you within a short commute. Enjoy the peace of mind that comes with knowing you're close to everything you need while experiencing the welcoming charm of Jasper County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near DMACC Newton Campus, IA",
      "seo_description": "Sundance Newton Apartments offers convenient living near DMACC Newton Campus. Ideal for students and staff with easy access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-apartments-near-mercyone",
      "search_query": "apartments near MercyOne Newton Medical Center Iowa",
      "category": "Hospital",
      "h1_title": "Apartments Near MercyOne Newton Medical Center",
      "h2_subtitle": "Live just minutes from MercyOne Newton Medical Center at Sundance Newton Apartments. Ideal for healthcare professionals and visitors.",
      "page_copy": "For those seeking proximity to MercyOne Newton Medical Center, Sundance Newton Apartments offers an exceptional living option. Situated in the welcoming community of Newton, IA, our apartments provide a convenient location for healthcare professionals and families needing easy access to the medical center.\n\nOur well-appointed units come equipped with large closets and modern kitchen conveniences like disposals, plus options for W/D hookups. The community also fosters a balanced lifestyle with amenities such as a playground and laundry facilities on-site. Choosing Sundance Newton means enjoying both comfort and practicality, all while remaining close to your workplace or loved ones receiving care at MercyOne Newton Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MercyOne Newton Medical Center, IA",
      "seo_description": "Sundance Newton Apartments offer convenient living near MercyOne Newton Medical Center, perfect for healthcare professionals and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-near-maytag-park",
      "search_query": "Sundance Newton Apartments near Maytag Park",
      "category": "Park",
      "h1_title": "Sundance Newton Apartments Near Maytag Park",
      "h2_subtitle": "Experience the charm of living near Maytag Park at Sundance Newton. Enjoy easy access to green spaces and outdoor activities.",
      "page_copy": "Sundance Newton Apartments offers a unique blend of comfort and location, especially for those who appreciate the great outdoors. Nestled near the iconic Maytag Park in Newton, IA, our community provides residents with the perfect balance of urban convenience and natural beauty.\n\nResidents can enjoy spacious interiors with large closets and modern amenities like W/D hookups and disposals. Right outside your door, Maytag Park invites you with its lush grounds, ideal for picnics or a casual stroll. Community features such as a playground and laundry facilities enhance the vibrant lifestyle fostered here at Sundance Newton, promising a home that’s as welcoming as its surroundings.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sundance Newton Apts Near Maytag Park, IA",
      "seo_description": "Discover Sundance Newton Apartments, perfectly located near Maytag Park in Newton, IA. Ideal for those who love easy access to green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-apartments-near-arboretum",
      "search_query": "Newton Arboretum & Botanical Gardens nearby apartments",
      "category": "Park",
      "h1_title": "Newton Arboretum & Botanical Gardens Nearby Apartments",
      "h2_subtitle": "Enjoy living near the lush Newton Arboretum & Botanical Gardens. Sundance Newton Apartments provides a tranquil setting close to nature's beauty.",
      "page_copy": "Discover the serene environment of Sundance Newton Apartments, ideally located near the Newton Arboretum & Botanical Gardens. This prime location in Newton, IA, offers residents the unique opportunity to live amidst nature's splendor while enjoying modern conveniences.\n\nOur apartments feature spacious living areas, large closets, and convenient W/D hookups, designed to cater to your lifestyle needs. Community amenities such as a playground and laundry facilities ensure a comfortable, engaging living experience. Just a short distance from the arboretum, enjoy a peaceful retreat with easy access to beautiful landscapes and walking paths, making Sundance Newton the perfect place for nature lovers and those seeking tranquility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Newton Arboretum & Botanical Gardens",
      "seo_description": "Live close to nature at Sundance Newton, with nearby access to the beautiful Newton Arboretum & Botanical Gardens. Enjoy tranquility and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-near-mariposa-county-park",
      "search_query": "Mariposa County Park IA apartment living",
      "category": "Park",
      "h1_title": "Mariposa County Park IA Apartment Living",
      "h2_subtitle": "Discover comfortable living close to Mariposa County Park. Sundance Newton Apartments offers convenience and natural beauty in Newton, IA.",
      "page_copy": "Experience the best of both worlds at Sundance Newton Apartments, located near the serene Mariposa County Park in Iowa. This ideal spot in Newton provides residents with a perfect mix of comfortable living and outdoor adventure, making it an excellent choice for those who appreciate a blend of nature and modern amenities.\n\nOur residents enjoy large closets, modern kitchen disposals, and options for W/D hookups in spacious apartments. Community conveniences include a playground and laundry facilities, designed to enhance daily living. With Mariposa County Park just a short distance away, weekends can be filled with hiking, picnicking, and embracing Iowa’s natural landscapes, making apartment life here both enjoyable and enriching.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Mariposa County Park IA",
      "seo_description": "Explore comfortable living at Sundance Newton Apartments near Mariposa County Park. Enjoy the best of modern amenities and nature's tranquility in Newton, IA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167519",
      "source": "generator",
      "page_item_url": "sundance-newton-near-agnes-patterson-park",
      "search_query": "Agnes Patterson Memorial Park close apartments Jasper County",
      "category": "Park",
      "h1_title": "Agnes Patterson Park Close Apartments Jasper County",
      "h2_subtitle": "Sundance Newton Apartments offers a perfect home near Agnes Patterson Memorial Park. Discover the convenience of Jasper County living.",
      "page_copy": "Welcome to Sundance Newton Apartments, where community living meets natural beauty close to Agnes Patterson Memorial Park. Situated in the heart of Jasper County, our location provides easy access to outdoor activities, making it ideal for those who enjoy an active lifestyle.\n\nOur spacious apartments come equipped with large closets and convenient W/D hookups, along with modern disposals. Community features such as a playground and laundry facilities enhance your living experience. Just minutes from Agnes Patterson Memorial Park, you can effortlessly enjoy sports, trails, and scenic views, all contributing to a balanced and fulfilling lifestyle at Sundance Newton.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Agnes Patterson Park, Jasper County",
      "seo_description": "Discover Sundance Newton Apartments in Jasper County, close to Agnes Patterson Memorial Park. Enjoy comfort and convenience in a scenic location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12067673335"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5685518"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N2PKLGH4"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "58388049222"
    },
    {
      "ID": "custom_tax_credit_properties",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjZLRnIzb2hoSTJZRzJoS25NbU0vRWc9PSIsInZhbHVlIjoiYkN6OWRPelBOcVpHSFNBSEVyRFlydz09IiwibWFjIjoiMDZiNzNiNTU2N2NjZjQ0Y2U3ODNmNzdmNWRlYjA4MGYxZWY2Y2QxNTJhOTc4YWVlZDFjNmFjOGVjMjIxMDQ2MCJ9"
    }
  ],
  "custom_repli_id": "12067673335",
  "custom_realpage_id": "5685518",
  "custom_google_gtm_id": "GTM-N2PKLGH4",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Prestige",
  "custom_hubspot_company_id": "58388049222",
  "custom_tax_credit_properties": "true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjZLRnIzb2hoSTJZRzJoS25NbU0vRWc9PSIsInZhbHVlIjoiYkN6OWRPelBOcVpHSFNBSEVyRFlydz09IiwibWFjIjoiMDZiNzNiNTU2N2NjZjQ0Y2U3ODNmNzdmNWRlYjA4MGYxZWY2Y2QxNTJhOTc4YWVlZDFjNmFjOGVjMjIxMDQ2MCJ9",
  "custom_audioeye_site_id": "205bade8-5434-442a-bdd5-ce8c0e4f1e63",
  "custom_audioeye_site_hash": "b83b03fbf0b8bb0b045375308d17e775"
};

export const generatedAt = '2026-09-23T21:46:13.373Z';
